export default "__VITE_ASSET__z0WrS87X__"